import type { IRequestReturnParams, IRequestReturnResponse } from "../interface/return";

/**
 * 반품 리뉴얼이 완료된 '예스아이씨', '네버댓', '카키스' 에서 사용함
 * refundDuties를 추가로 반환해주는 경우만 다르고 나머지 로직은 requestReturn 와 동일함
 * */
export const requestReturn = async ({
  shop,
  domain = "",
  orderId,
  returnLineItems,
  returnImageUrls,
  returnShippingFee,
}: IRequestReturnParams): Promise<IRequestReturnResponse | undefined> => {
  const url = "https://m5uguvf75yvezp3wdbqwg2de6q0mswvg.lambda-url.ap-northeast-2.on.aws/"; //common_return_request_v2

  try {
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ shop, orderId, returnLineItems, returnImageUrls, domain, returnShippingFee }),
    }).then((res) => res);

    if (response.status === 200) {
      return (await response.json()) as IRequestReturnResponse;
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};

/**
 * '웰빙'에서만 사용중
 * customeAttributes를 업데이트해주는 로직 추가됨
 * */
export const requestReturnV2 = async ({
  shop,
  domain = "",
  orderId,
  returnLineItems,
  returnImageUrls,
  returnShippingFee,
}: IRequestReturnParams): Promise<IRequestReturnResponse | undefined> => {
  const url = "https://l6u2aq4u2oqs53kllcecoqyzya0jobbp.lambda-url.ap-northeast-2.on.aws/"; // common_return_request_v3

  try {
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ shop, orderId, returnLineItems, returnImageUrls, domain, returnShippingFee }),
    }).then((res) => res);

    if (response.status === 200) {
      return (await response.json()) as IRequestReturnResponse;
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};
